// extracted by mini-css-extract-plugin
module.exports = {"suggestedCities":"suggestedCities__suggestedCities1U9","more":"suggestedCities__more2Vy","less":"suggestedCities__less2yj","paragraph":"suggestedCities__paragraph3_Q"};